module.exports = __webpack_public_path__ + "img/answer1.1a2c0841.jpg";